import { Component, inject, OnInit } from '@angular/core';
import { Avatar } from "primeng/avatar";
import { Button } from "primeng/button";
import { Divider } from "primeng/divider";
import { ThemeSelectButtonComponent } from "../theme-select-button/theme-select-button.component";
import { AuthService } from "../../../auth/services/auth.service";
import { Router } from "@angular/router";
import { Tag } from "primeng/tag";

@Component({
  selector: 'app-user-panel',
  imports: [
    Avatar,
    Button,
    Divider,
    ThemeSelectButtonComponent,
    Tag
  ],
  templateUrl: './user-panel.component.html',
  styleUrl: './user-panel.component.scss',
  host: {
    class: 'hidden absolute top-[3.25rem] right-0 w-90 max-w-100wh p-4 bg-surface-0 dark:bg-surface-900 border border-surface rounded-border origin-top shadow-[0px_3px_5px_rgba(0,0,0,0.02),0px_0px_2px_rgba(0,0,0,0.05),0px_1px_4px_rgba(0,0,0,0.08)]'
  }
})
export class UserPanelComponent implements OnInit {
  userRoles: string[] = [];
  protected readonly AuthService = AuthService;
  protected authService = inject(AuthService);
  protected router = inject(Router);

  ngOnInit() {
    this.authService.currentUser$.subscribe(user => {
      if (!user) return;
      this.userRoles = user.groups.map(group => group.name) || [];
      if (user.isStaff) this.userRoles.push("Staff");
      if (user.isSuperuser) this.userRoles.push("Superuser");
    });
  }

  onClickLogout() {
    this.authService.logout().then(() => {
    });
  }
}
